<template>
  <div id="app">
    <router-view />
    <LoginOverlay />
    <BalanceBillingModal />
  </div>
</template>

<script>
import LoginOverlay from './components/LoginOverlay.vue'
import BalanceBillingModal from './components/BalanceBillingModal.vue'
import { restoreBalanceBillingPendingAfterLogin } from './utils/balanceBillingGate'
import { prefetchVipPlans } from './utils/vipPlansCache'

export default {
  name: 'App',
  components: { LoginOverlay, BalanceBillingModal },
  mounted() {
    restoreBalanceBillingPendingAfterLogin()
    prefetchVipPlans().catch(() => {})
  }
}
</script>

<style>
/* App 样式已在 global.css 中定义 */
</style>
